import { apiHelper } from "../../../utils/apiHelper/apiHelper";
import { config } from "../../../config/config";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { helperFunction } from "../../../utils/helperFunctions";

export const login = createAsyncThunk(
    'auth/login',
     async (payload, { rejectWithValue }) => {
      try {
        console.log(payload, " ================================>>>>>>>>>> ")
        const response = await apiHelper("post",`${config.serverUrl}/api/public/user/log-in`,payload);

        return response.data;
      } catch (err) {
        return rejectWithValue(err.response.data);
      }
    }
  );

  export const register = createAsyncThunk(
    'auth/register',
     async (payload, { rejectWithValue }) => {
      try {
        const response = await apiHelper("post",`/api/public/user/sign-up`,payload);
        if(response.data){
          let { data } = response
          helperFunction.saveItem('userId', data.data.id)
          return response.data;
        }
      } catch (err) {
        return rejectWithValue(err.response.data);
      }
    }
  );
  
  export const resetPassword = createAsyncThunk(
    'auth/resetPassword',
     async (payload, { rejectWithValue }) => {
      try {
        console.log(payload, " ================================>>>>>>>>>> ")
        const response = await apiHelper("patch",`${config.serverUrl}/reset-password`,payload);
        return response.data;
      } catch (err) {
        return rejectWithValue(err.response.data);
      }
    }
  );
